module.exports = __webpack_public_path__ + "media/images/texture-effect-e8514e37f319459d5f2a37ce4d885c35.png";